<script setup>
    import { defineProps } from "vue";

    const props = defineProps({
        iconWidth: String,
        iconHeight: String,
    });
</script>


<template>
    <svg 
        fill="currentColor" 
        :width="iconWidth" 
        :height="iconHeight" 
        viewBox="-1 0 19 19" 
        xmlns="http://www.w3.org/2000/svg" 
        class="cf-icon-svg"
    >
        <path 
            d="M16.417 9.583A7.917 7.917 0 1 1 8.5 1.666a7.917 7.917 0 0 1 7.917 7.917zm-3.297 3.103-2.424-2.424a3.978 3.978 0 1 0-1.119 
                1.12l2.424 2.423a.791.791 0 1 0 1.119-1.12zM9.633 5.808a3.189 3.189 0 1 1-2.255-.934 3.167 3.167 0 0 1 2.255.934z"
            />
        </svg>
</template>